import clsx from 'clsx';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function VehicleDiagLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <li className="car_diagnosis_item skeleton">
      <div className="section_container">
        <strong className="car_diagnosis_title">{t('T30002')}</strong>
        <div className="badge_box">
          <span className={clsx('badge badge_basic_container badge_20px')}>{t('T20079')}</span>
        </div>
        <span className={clsx('ic ic_tire_good')} />
      </div>
    </li>
  );
}

export default VehicleDiagLoadingKr;
